<template>
  <div>
    <div class="posts-info">
      <a href="#" class="info-text category">{{ category }}</a>
      <div class="info-divider"></div>
      <div class="info-text">{{ date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.posts-info {
  display: flex;
  margin-top: 12px;
  margin-bottom: 5px;
  align-items: center;

  .info-text.category {
    color: #5b6066;
    font-size: 12px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: normal;
    text-transform: uppercase;
    cursor: default;
  }

  .info-divider {
    width: 4px;
    height: 4px;
    margin-right: 6px;
    margin-left: 6px;
    border-radius: 12px;
    background-color: #5b6066;
    color: #5b6066;
  }

  .info-text {
    color: #5b6066;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-decoration: none;
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/BlogPostInfo.vue